<template>
  <b-form-group label="Value:" :invalid-feedback="valueInvalidFeedback">
    <b-form-textarea
      :value="$v.value.$model"
      @input="onInput($event)"
      :state="validateState('value')"
    >
    </b-form-textarea>
  </b-form-group>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { jsonValidator } from '@/helpers/customValidators';

export default {
  name: 'SettingFieldJson',
  mixins: [validationMixin],
  props: {
    initialValue: {
      validator: (prop) => typeof prop === 'string' || prop === null,
      default: null,
    },
  },
  data() {
    return {
      value: this.initialValue,
    };
  },
  validations: {
    value: {
      json: jsonValidator,
    },
  },
  computed: {
    valueInvalidFeedback() {
      return !this.$v.value.json ? 'Value must be a valid json.' : null;
    },
  },
  methods: {
    onInput(newValue) {
      this.value = newValue;
      this.$v.value.$touch();

      this.$emit('input', newValue);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];

      this.$emit('valid', $dirty ? !$error : false);

      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped></style>
